<template>
  <ModuleWrapper :moduleId="moduleId" :image="imageSrcPath('assets/branding/logo.svg')" title="Social Media Thumbnail">
    <template #main>
      <ImageUploadButton
        label="This image will display when you share your event registration page link online. Upload a PNG or JPG"
        :image="thumbnailURL"
        :acceptedTypes="['.png', '.jpg', '.jpeg', '.webp']"
        :s3BucketPath="s3BucketPath"
        @changeImageUrl="handleImageUrlChange"
      />
    </template>
  </ModuleWrapper>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

import ModuleWrapper from './ModuleWrapper.vue';
import ImageUploadButton from '../components/ImageUploadButton.vue';

import { STATIC_ASSETS } from '@/constants';

export default {
  name: 'SocialMediaThumbnail',
  components: {
    ModuleWrapper,
    ImageUploadButton
  },
  props: {
    moduleId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      s3BucketPath: `${STATIC_ASSETS.SOCIAL_MEDIA_THUMBNAIL_PATH}/events/${this.$route.params.eventId}/`
    };
  },
  computed: {
    ...mapGetters('branding', {
      getInitialModuleData: 'getInitialModuleData'
    }),
    thumbnailURL() {
      const moduleKeys = ['social_media_thumbnail'];
      const { social_media_thumbnail } = this.getInitialModuleData(moduleKeys);
      return social_media_thumbnail;
    }
  },
  methods: {
    ...mapMutations('branding', {
      setChangesMadeInEvent: 'setChangesMadeInEvent'
    }),
    handleImageUrlChange(url) {
      this.setChangesMadeInEvent({ social_media_thumbnail: url });
    }
  }
};
</script>
